import { Outlet, Navigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import NavigationBar from '../NavigationBar';

const RutaProtegida = () => {

    const { auth, cargando } = useAuth();
    if(cargando) return 'Cargando...'
    return (
        <>
            {auth.id ? 
            (
                <div className='bg-gray-100'>
                    <NavigationBar />

                    <div className='md:flex md:min-h-screen'>

                        <main className='p-10 flex-1 '>
                            <Outlet />
                        </main>
                    </div>
                </div>
            ) : <Navigate to="/" />}
        </>
    )
}

export default RutaProtegida